import "media-chrome/react";
import { MediaTheme } from "media-chrome/react/media-theme";
import "media-chrome/react/menu";
import { t } from "@/i18n-js/instance";
import { themeTemplateHTML } from "./template";

const i18nRoot = "media_player.template.messages";

// Make sure vertical videos don't exceed the height of the viewport
const playerMaxHeight = "calc(100vh - 16rem)";

interface PlayerThemeProps {
  children: React.ReactNode;
  downloadable?: boolean;
  downloadUrl?: string;
  fullHeight?: boolean;
  playbackRates?: string;
}

export const PlayerTheme = ({
  playbackRates = "0.5 0.75 1 1.25 1.5 1.75 2",
  downloadable = false,
  downloadUrl,
  fullHeight = false,
  children,
}: PlayerThemeProps) => (
  <>
    <template
      id="media-theme-default"
      dangerouslySetInnerHTML={{ __html: themeTemplateHTML }}
    />
    <MediaTheme
      template="media-theme-default"
      style={{
        width: "100%",
        ...(fullHeight
          ? { height: "100%" }
          : { maxHeight: playerMaxHeight, aspectRatio: "16/9" }),
        "--media-webkit-text-track-transform": "translateY(-60px)",
      }}
      rates={playbackRates}
      downloadable={downloadable}
      downloadUrl={downloadUrl}
      playbackSpeedLabel={t([i18nRoot, "playback_speed"])}
      qualityLabel={t([i18nRoot, "quality"])}
      subtitlesLabel={t([i18nRoot, "subtitles"])}
    >
      {children}
    </MediaTheme>
  </>
);
